<div dropdown #dropdown="bs-dropdown" placement="bottom right">
    <div
        dropdownToggle
        role="button"
        tabindex="0"
        aria-expanded="true"
        [attr.aria-label]="'User settings menu' | translate"
        (keyup.enter)="dropdown.isOpen ? dropdown.hide() : dropdown.show()">
        <sb-user-avatar
            class="pointer"
            [user]="user"
            [tooltipText]="'Profile and settings' | translate"
            [tooltipPlacement]="'left'"
            [isNeedTooltip]="!customerSettings?.isTrialExpired">
        </sb-user-avatar>
        <span class="caret"></span>
    </div>

    <ul
        id="dropdown-basic"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        aria-labelledby="button-basic">
        @if (!customerSettings.isTrialExpired) {
            @if (!user.isSystemAdmin) {
                <li role="menuitem" [ngClass]="{ active: activeState.is('tickets') }">
                    <a class="dropdown-item link" [href]="environment.inboxUrl + '/' + communityName + '/tickets'">
                        {{ 'Inbox' | translate }}
                    </a>
                </li>
            }
            @if (!user.isReadOnlyUser && !user.isSystemAdmin) {
                <li role="menuitem" [ngClass]="{ active: activeState.is('reports') }">
                    <a class="dropdown-item link" [href]="environment.inboxUrl + '/' + communityName + '/reports'">
                        {{ 'Reports' | translate }}
                    </a>
                </li>
            }
            @if (user.hasAccessToFAQ) {
                <li role="menuitem">
                    <a class="dropdown-item link" [href]="environment.faqUrl + communityName + '/admin'">
                        {{ 'FAQ configuration' | translate }}
                    </a>
                </li>
            }
            @if (user.hasAccessToGDPR) {
                <li role="menuitem">
                    <a class="dropdown-item link" [href]="environment.accessRequestsUrl + communityName">
                        {{ 'Access requests' | translate }}
                    </a>
                </li>
            }
            <li role="menuitem">
                <a class="dropdown-item link" [href]="personalSettingsUrl"> {{ 'Personal settings' | translate }} </a>
            </li>
            @if (user?.isAdmin || user?.isSystemAdmin) {
                <li role="menuitem">
                    <a class="dropdown-item link" [href]="settingsUrl"> {{ 'Settings' | translate }} </a>
                </li>
            }
        }
        <li role="menuitem">
            <a
                class="dropdown-item link"
                target="_blank"
                [href]="
                    language === 'nb'
                        ? 'https://faq.socialboards.com/socialboards/'
                        : 'https://faq.socialboards.com/support/'
                ">
                {{ 'Support' | translate }}
            </a>
        </li>
        <li class="divider dropdown-divider"></li>

        <li role="menuitem">
            <button class="dropdown-item pointer" (click)="logout.emit($event)">
                {{ 'Log out' | translate }}
                ({{ user.name || user.email | truncate: 30 }})
            </button>
        </li>
    </ul>
</div>
